import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

//import components
import DetailsListItemSingle from './DetailsListItemSingle.js';
import DetailsListItemContent from './DetailsListItemContent.js';

class DetailsListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        };
    };

    componentDidMount() {
        const {children, isTouched} = this.props;
        
        if (children && children.length > 0 && !isTouched) {
            this.setState({isOpened: true});
        }
    };

    componentDidUpdate(prevProps, prevState) {
        const {children} = this.props;

        if (!prevProps.children && children && !prevState.isOpened) {
            this.setState({isOpened: true});
        }
    }

    toggleOpened = () => {
        const {getFieldChildren, id, children, expansible, setIsTouched} = this.props;

        setIsTouched();

        if (!children && expansible) {
            getFieldChildren(id);
        }

        if (children) {
            this.setState({isOpened: !this.state.isOpened});
        }
    };

    render() {
        const {isOpened} = this.state;
        const { label, children, getFieldChildren, id, shortDescription, recordsNumber, contact, setIsTouched, isTouched, currentHeading, setActiveElem} = this.props;

        return (
            <li className="structure__list-item">
                <div className="structure__list-item__container">
                    <button className={isOpened ? "structure__hide" : "structure__open"}
                            onClick={() => this.toggleOpened()}>
                        {!isOpened && <span>+</span>}
                        {isOpened && <span>-</span>}
                    </button>
                    <DetailsListItemContent setActiveElem={setActiveElem} id={id} currentHeading={currentHeading} label={label} shortDescription={shortDescription} recordsNumber={recordsNumber}
                        contact={contact} />
                </div>
                {isOpened &&
                    <ul className="structure__inner-list">
                        {children.map((child, index) => child.expansible || (child.children && child.children.length > 0) ?
                            <DetailsListItem key={index} {...child}
                                setIsTouched={setIsTouched}
                                isTouched={isTouched}
                                setActiveElem={setActiveElem}
                                currentHeading={currentHeading}
                                getFieldChildren={getFieldChildren}/>
                            : <DetailsListItemSingle setActiveElem={setActiveElem} currentHeading={currentHeading} key={index} {...child} />)}
                    </ul>}
            </li>
        );
    };
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
});

export default withRouter(connect(mapStateToProps)(DetailsListItem));



// WEBPACK FOOTER //
// ./src/components/characteristics-details/DetailsListItem.js